




























































































import Vue from "vue";
import { mapState } from "vuex";
import { RootState } from "@/store";

// Vue components
import UserMFASwitch from "@/views/App/Tools/UserManagement/UserMFASwitch.vue";
import EditClientUserModal from "@/views/App/Tools/UserManagement/EditClientUserModal.vue";
import DeleteClientUserModal from "@/views/App/Tools/UserManagement/DeleteClientUserModal.vue";

// Model
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { FetchClientUsersCommand } from "@/model/communication/users/FetchClientUsersCommand";
import { DeleteClientUserCommand } from "@/model/communication/users/DeleteClientUserCommand";
import { DeleteClientUserReqData } from "@/model/communication/users/DeleteClientUserReqData";
import { Organization } from "@/model/data/organizations/Organization";
import { ClientUser } from "@/model/data/authentication/ClientUser";

export default Vue.extend({
    components: {
        UserMFASwitch,
        EditClientUserModal,
        DeleteClientUserModal,
    },
    data() {
        return {
            profileNameInternalString: "@$",
            loading: false,
            showErrorAlert: false,
            search: "",
            users: [],
            showEditUserDialog: false,
            showDeleteUserDialog: false,
            userToEdit: null,
            userToDelete: null,
            filterUsersByProfile: false,
            selectedProfileName: null,
        };
    },
    computed: {
        ...mapState({ authUser: (state: RootState) => state.authMod.currentUser }),

        headers() {
            let res = [];

            res.push({ text: this.$t("common.name"), value: "name" });
            res.push({ text: this.$t("user_management.profile"), value: "profile.name" });
            res.push({ text: this.$t("user_management.visibility"), value: "visibility", sortable: false });
            if (this.organization == null) res.push({ text: this.$t("common.actions"), value: "action", sortable: false });
            if (this.organization == null) res.push({ text: this.$t("login.mfa"), value: "mfa", sortable: false, width: "1" });
            return res;
        },
    },
    props: {
        organization: { type: Object as () => Organization, required: false },
    },
    watch: {
        organization() {
            this.getUsers();
        },
    },
    methods: {
        openEditUserDialog(user: ClientUser) {
            this.userToEdit = user;
            this.showEditUserDialog = true;
        },

        openDeleteUserDialog(user: ClientUser) {
            this.userToDelete = user;
            this.showDeleteUserDialog = true;
        },

        filterUsersTable(profileName: string) {
            this.filterUsersByProfile = true;
            this.selectedProfileName = profileName;
        },

        async getUsers() {
            this.showEditUserDialog = false;
            this.userToEdit = null;
            this.userToDelete = null;
            this.filterUsersByProfile = false;
            this.selectedProfileName = null;

            if (this.$refs.editClientUserModal) this.$refs.editClientUserModal.getProfiles();

            if (!this.loading) {
                try {
                    this.loading = true;
                    let res = await new FetchClientUsersCommand().execute();
                    if (res.responseStatus == ApiResponseStatusEnum.Success) {
                        if (this.organization != null)
                            if (res.clientUsers.some((u) => u.profile.organizationId && u.profile.organizationId == (this.organization as Organization).id))
                                this.users = res.clientUsers.filter((u) => u.profile.organizationId && u.profile.organizationId == (this.organization as Organization).id);
                            else this.users = [];
                        else this.users = res.clientUsers;
                    }
                    this.loading = false;
                } catch (error) {
                    console.log("Something went wrong during FetchClientUsersCommand execution: ", error);
                    this.loading = false;
                }
            }
        },

        async deleteUser() {
            try {
                this.showDeleteUserDialog = false;
                const res = await new DeleteClientUserCommand(new DeleteClientUserReqData(this.userToDelete.name)).execute();
                if (res.responseStatus == ApiResponseStatusEnum.Success) {
                    this.getUsers();
                    this.$emit("getProfiles");
                } else this.showErrorAlert = true;
            } catch (error) {
                console.log("Something went wrong during DeleteClientUserCommand execution: ", error);
            }
        },
    },
    mounted() {
        this.getUsers();
    },
});
